import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  IconButton,
  Icon,
  VStack,
} from '@chakra-ui/react';
import { EditIcon, ArrowUpIcon, ArrowDownIcon, ViewIcon } from '@chakra-ui/icons';
import { useNavigate} from 'react-router-dom';
import {useAppSelector} from '../Hooks/useAppSelector';
import {DayWiseRecord, DayWiseVisitStatusRecord, MarketScanFormData} from '../Constants/type';
import {fetchMarketScanRecords, getMarketScanRecordById, selectMarketScanRecords} from '../Redux/MarketScanSlice';
import Toast from '../Components/Toast';
import {useAppDispatch} from '../Hooks/useAppDispatch';
import {themeConfig} from '..';

const MarketScan: React.FC = () => {
  const navigate=useNavigate()

  //Get the marketScanRecords from the redux
  const records = useAppSelector<MarketScanFormData[]>(selectMarketScanRecords);
  const dispatch=useAppDispatch();
  console.log(records);
  

  // const [marketScanRecords,setMarketScanRecords] = useState<MarketScanFormData[]>([] as MarketScanFormData[]);


  const [sortField, setSortField] = useState<keyof MarketScanFormData | null>(null);
  const [sortOrder, setSortOrder] = useState<'asc' | 'desc'>('asc');

  useEffect(()=>{
    console.log("Fetch All the records",records);
    dispatch(fetchMarketScanRecords());
  },[])


  //Here we will route to the form
  const handleCreateNew = () => {
    navigate("/market-scan/create");
  };

  //Route to create Form but with all the values fitted
  const handleEdit = (id: string) => {
    dispatch(getMarketScanRecordById(id, () => {
      navigate("/market-scan/edit"); 
    }));
  };


  const handleViewAll = (id: string) => {
    dispatch(getMarketScanRecordById(id, () => {
      navigate("/market-scan/details"); 
    }));
  }

  function getLatestVisitStatus(arr:DayWiseVisitStatusRecord[]){
    if(arr.length===0) return "-";

    const lastIdx=arr.length-1;
    return Array.isArray(arr[lastIdx].val) ? arr[lastIdx].val.join(', ') : "-"
  }

  function getLatestConversionChances(arr:DayWiseRecord[]){
    //If no value is there
    if(arr.length===0) return "-";

    const lastIdx=arr.length-1;
    return arr[lastIdx].val;

  }

  return (
    <div>
      <Toast/>
      <Box textAlign="center">
        <Button onClick={handleCreateNew} backgroundColor={themeConfig.colors.green0}  mb={8} mt={4} textAlign="center">
          CREATE NEW
        </Button>
      </Box>
      <Table variant="simple" size="sm" w="100%">
        <Thead>
          <Tr>
            <Th w={"40%"} >
              Shop Name/ <br/>Area <br/>{sortField === 'address' && sortOrder === 'asc' ? <Icon as={ArrowUpIcon} boxSize={2} /> : <Icon as={ArrowDownIcon} boxSize={2} />}
            </Th>
            <Th >
              Visit Status/ Conversion Status  {sortField === 'shop_name' && sortOrder === 'asc' ? <Icon as={ArrowUpIcon} boxSize={2} /> : <Icon as={ArrowDownIcon} boxSize={2} />}
            </Th>
            <Th />
          </Tr>
        </Thead>
        <Tbody>
          {records.map((shop:MarketScanFormData,index:number) => (
            <Tr key={index}>
              <Td>{shop.shop_name}/ {shop.area_description}</Td>
              <Td>
                {getLatestVisitStatus(shop.visit_status)}
                /
                {getLatestConversionChances(shop.conversion_chances)}
              </Td>
              <Td>
                <VStack>
                  <IconButton
                    size={"sm"}
                    aria-label="Edit"
                    icon={<Icon as={EditIcon} />}
                    onClick={() => handleEdit(shop.id)}
                  />
                  <IconButton
                    size={"sm"}
                    aria-label="View All"
                    icon={<Icon as={ViewIcon} />}
                    onClick={() => handleViewAll(shop.id)}
                  />
                </VStack>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </div>
  );
};

export default MarketScan;
